import { scoreLabels } from 'components/ReceptionScore/model';

type Rating = {
  labelCode?: string;
  labelName?: string;
  scoreType?: string;
  reasonCode?: string;
  replyOption?: string;
};

/** Translate stable label identities, preserving unknown/custom snapshots. */
export function ratingLabel(record: Rating, translate: (key: string, fallback: string) => string) {
  const code =
    record.labelCode ||
    (record.scoreType === 'POSITIVE'
      ? 'POSITIVE'
      : record.scoreType === 'NEGATIVE' && record.reasonCode
      ? `NEGATIVE_${record.reasonCode}`
      : !record.scoreType && record.replyOption === '1'
      ? 'POSITIVE'
      : !record.scoreType && record.replyOption === '2'
      ? 'NEGATIVE_OTHER'
      : undefined);
  const label = scoreLabels.find((item) => item.code === code);
  return label
    ? translate(`receptionScore.label.${label.code}`, label.name)
    : record.labelName || '—';
}
